import axios from "axios";
import { showSessionExpiredModal } from "./sessionExpiredHelper";
import { AUTH_HEADER, buildAuthHeader, isTrustedApiUrl } from "./authToken";

let isRedirecting = false;

const hasAuthHeader = (headers) =>
  !!headers && Object.keys(headers).some((key) => key.toLowerCase() === "authorization");

/**
 * warnning in dev mode only,, about a credential still travelling in the URL.
 *
 */
const warnOnTokenParam = (config) => {
  if (process.env.NODE_ENV === "production") return;

  const inParams = config.params && typeof config.params === "object" && "token" in config.params;

  if (inParams || config.url?.includes("token=")) {
    console.warn(
      `[auth] Request to ${config.url} still carries a "token" query param. ` +
        "Pass the credential via the Authorization header instead — URLs leak " +
        "into browser history, Referer headers and server access logs.",
    );
  }
};

const resolveUrl = (config) => {
  try {
    return new URL(config?.url ?? "", config?.baseURL || window.location.origin).toString();
  } catch {
    return null;
  }
};

const isOwnApi = (config) => {
  const url = resolveUrl(config);
  return !!url && isTrustedApiUrl(url);
};

axios.interceptors.request.use((config) => {
  // Never attach the session credential to third-party hosts. The API-testing

  if (!isOwnApi(config)) {
    return config;
  }

  warnOnTokenParam(config);

  // An explicit header wins: public report links authenticate with a credential
  // from the route, not the logged-in session.
  if (!hasAuthHeader(config.headers)) {
    const authHeader = buildAuthHeader();
    if (authHeader[AUTH_HEADER]) {
      config.headers = { ...config.headers, ...authHeader };
    }
  }

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && isOwnApi(error.config) && !isRedirecting) {
      isRedirecting = true;

      localStorage.removeItem("userDetail");

      showSessionExpiredModal(() => {
        window.location.replace("/LoginPage");
      }, 3);
    }

    return Promise.reject(error);
  },
);
